import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Button, Spinner } from 'react-bootstrap';
import { withFirebase } from '../Firebase';
import { Container, Row, Col } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';


import { dateFormatUtil } from '../Utilities';
import RestServices from '../services/RestServices.js';
import './style.css';
const SignUpPage = () => (
    <div>
        <SignUpForm />
    </div>
);



const INITIAL_STATE = {
    FullName: '',
    PhoneNumber: '',
    WhatsAppNumber:'',
    HouseNumber: '',
    Area: '',
    City: '',
    District: '',
    PinCode: '',
    State: '',
    EmailId: '',
    Address:false,
    errorMessage: '',
    successMessage: '',
    flag: false,
    sameAsMobileChecked: false,
    showLoading: false,
    submitted:false,
    AllStates: [
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Andaman and Nicobar Islands',
        'Bihar',
        'Chandigarh',
        'Chhattisgarh',
        'Delhi',
        'Dadra and Nagar Haveli and Daman and Diu',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jammu and Kashmir',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Ladakh',
        'Lakshadweep',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Puducherry',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal'
    ]
};

class SignUpFormBase extends Component {
    _isMounted = false;
    autocomplete = null

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    async componentDidMount() {
        this._isMounted = true;
        this.autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete'), {})
        this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
        
    }
    handlePlaceSelect=()=> {
        let place = this.autocomplete.getPlace()
        //console.log(place.address_components)
        for (var i=0; i<place.address_components.length; i++)
        {
            var area = place.address_components[0].long_name+' '+place.address_components[1].long_name;


            if (place.address_components[i].types[0] == "locality") {
            var city = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] == "administrative_area_level_2") {
            var district = place.address_components[i].long_name;
            }

            if (place.address_components[i].types[0] == "administrative_area_level_1") {
            var state = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] == "country") {
            var country = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] == "postal_code") {
            var postal_code = place.address_components[i].long_name;
            }
        }
       
        this.setState({
          Address:true,  
          Area: area,
          City: city,
          District: district,
          State: state,
          PinCode: postal_code,
        })
      }

    componentWillUnmount() {
        this._isMounted = false;
    }

    resetForm = async () => {
        if (this._isMounted) {
            this.setState({
                ['FullName']: '',
                ['PhoneNumber']: '',
                ['EmailId']: '',
                ['WhatsAppNumber']: '',
                ['Address']: false,
                ['HouseNumber']: '',
                ['City']: '',
                ['Area']: '',
                ['PinCode']: '',
                ['State']: '',
                ['District']: '',
            });
            document.getElementById('autocomplete').value='';
        }
    };

    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }
    
    AddVirtualAccount= (UserUniqeID) => {

        if (this._isMounted) {
            this.setState({
                showLoading: true
            });
        }

        let UniqeID =UserUniqeID.substring(0,4)
        UniqeID = UniqeID+this.makeRandomId(4)
        let descriptor = UniqeID.padStart(12, 'S');
        descriptor = descriptor.substring(0,12)
        let bodydata = {
            UniqeID: descriptor
        };
        
        RestServices.GlobalPost(
            '',
            bodydata,
            'razorpay/CreateVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                if(responseData.error){
                    if (this._isMounted) {
                        this.setState({
                        showLoading: false,
                        flag: false,
                        successMessage: '',
                        errorMessage: responseData.error.description
                        });
                    }
                }
                if(responseData.receivers){
                    let receiversData = []
                    receiversData['receivers'] = responseData.receivers
                    receiversData['virtualId']= responseData.id
                    this.UpdateVirtualAccounts(receiversData,UserUniqeID)
                }
                
            })
        

    }
    UpdateVirtualAccounts = (VirtualAccountsData,UserUniqeID) => {
        let bodydata = {
            UniqeID: UserUniqeID,
            VirtualAccounts: VirtualAccountsData.receivers?VirtualAccountsData.receivers:'',
            virtualId: VirtualAccountsData.virtualId?VirtualAccountsData.virtualId:'',
            UserRole: 'StoreCP',
        };
        
        RestServices.GlobalPost(
            '',
            bodydata,
            'profiles/updateVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                if(responseData.error){
                    if (this._isMounted) {
                        this.setState({
                        showLoading: false,
                        flag: false,
                        successMessage: '',
                        errorMessage: responseData.error.description
                        });
                    }
                }else{
                    if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        flag: false,
                        errorMessage: '',
                        successMessage: "Your signup request has been successfully submitted. Your request will be validated and an access for the Indiabuys portal will be provided soon."
                                
                    });
                }
            }

                
            })

    }


    onSubmit = async () => {
        var validationResult = this.validateForm();
        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({ errorMessage: validationResult.errorMsg });
            }
        } else {
            if (this._isMounted) {
                this.setState({submitted:true, showLoading: true, error: null });
            }
            let signUpData = {
                FullName: this.state.FullName,
                PhoneNumber: '+91' + this.state.PhoneNumber.replace('+91', ''),
                WhatsAppNumber:
                    '+91' + this.state.WhatsAppNumber.replace('+91', ''),
                EmailId: this.state.EmailId,
                HouseNumber: this.state.HouseNumber,
                City: this.state.City,
                Area: this.state.Area,
                PinCode: this.state.PinCode,
                State: this.state.State,
                District: this.state.District,
                Status: 'PENDING_VERIFICATION',
                RequestedTimeStamp: dateFormatUtil(),
                LastUpdatedTimeStamp: dateFormatUtil(),
                UserRole: 'StoreCP',
                UpdatedBy: 'Self'
            };

            await RestServices.signUpStoreOwners(signUpData)
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                showLoading: false,
                                submitted:false,
                                flag: false,
                                errorMessage: responseData.error
                            });
                        }
                    } else {
                        if (responseData.status) {
                            this.resetForm();
                            if(responseData.UniqeID && responseData.UniqeID!=''){
                                this.AddVirtualAccount(responseData.UniqeID)
                            }else{
                            
                            if (this._isMounted) {
                                this.setState({
                                    showLoading: false,
                                    submitted:false,
                                    flag: false,
                                    errorMessage: '',
                                    successMessage: "Your signup request has been successfully submitted. Your request will be validated and an access for the Indiabuys portal will be provided soon."
                                });
                            }
                        }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    showLoading: false,
                                    submitted:false,
                                    flag: false,
                                    successMessage: '',
                                    errorMessage: responseData.message
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            submitted:false,
                            flag: false,
                            errorMessage: err.message
                        });
                    }
                });
        }
    };

    onChangeValues = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        if (
            this.state.sameAsMobileChecked &&
            event.target.name === 'PhoneNumber'
        ) {
            this.setState({ ['WhatsAppNumber']: event.target.value });
        }
    };

    handleChange = (event) => {
        this.setState({ sameAsMobileChecked: !this.state.sameAsMobileChecked });
        if (this.state.PhoneNumber != '') {
            if (this.state.sameAsMobileChecked) {
                this.setState({ ['WhatsAppNumber']: '' });
            } else {
                this.setState({ ['WhatsAppNumber']: this.state.PhoneNumber });
            }
        }
    };

    render() {
        const errorMessage = this.state.errorMessage;
        const successMessage = this.state.successMessage;

        const isInvalid =
            this.state.FullName === '' ||
            this.state.PhoneNumber === '' ||
            this.state.HouseNumber === '' ||
            this.state.Address === false ||
            this.state.EmailId === '' ||
            this.state.submitted === true;

        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <Col md={{ span: 8, offset: 2 }} style={{marginBottom:'20px',background:'#ffffff'}}>
                        {this.state.successMessage =='' &&(
                        <div>
                            <h3 align="center" style={{marginTop:'10px',marginBottom:'20px'}}>Create Account</h3>

                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Full Name (As per PAN Card)</Form.Label>
                                <Form.Control
                                    placeholder="Enter Full Name"
                                    type="text"
                                    name="FullName"
                                    value={this.state.FullName}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    placeholder="Enter Email ID"
                                    type="email"
                                    name="EmailId"
                                    value={this.state.EmailId}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>


                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Mobile Number</Form.Label>
                                <Form.Control
                                    placeholder="Enter Mobile Number"
                                    type="text"
                                    name="PhoneNumber"
                                    value={this.state.PhoneNumber}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>
                        
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Whatsapp Number 
                                    
                                </Form.Label>
                                <span className="WhatsAppNumberOption">
                                    <input
                                        type="checkbox"
                                        name="sameAsMobileChecked"
                                        onChange={this.handleChange}
                                    />{' '}
                                    Same as Mobile
                                </span>
                                <Form.Control
                                    placeholder="Enter WhatsApp Number"
                                    type="text"
                                    name="WhatsAppNumber"
                                    value={this.state.WhatsAppNumber}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>
                        
                    

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>House Number</Form.Label>
                        <Form.Control
                            placeholder="Enter House Number"
                            type="text"
                            name="HouseNumber"
                            value={this.state.HouseNumber}
                            onChange={this.onChangeValues}
                            autoComplete="street-address"
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Address (Search location)</Form.Label>
                        <Form.Control
                            placeholder="Search location"
                            type="text"
                            ref="input"
                            id="autocomplete"
                        />
                    </Form.Group>
                </Form.Row>

                {this.state.Address &&<div>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Area</Form.Label>
                        <Form.Control
                            placeholder="Area"
                            type="text"
                            name="Area"
                            value={this.state.Area}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            placeholder="Enter City/Town"
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Pin Code</Form.Label>
                        <Form.Control
                            placeholder="Enter Pin Code"
                            type="text"
                            name="PinCode"
                            value={this.state.PinCode}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            placeholder="Enter District"
                            type="text"
                            name="District"
                            value={this.state.District}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>
                        <Autocomplete
                            name="State"
                            value={this.state.State}
                            onChange={(event, newValue) => {
                                this.setState({ State: newValue });
                            }}
                            id="user_State"
                            options={this.state.AllStates.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                 </Form.Row>

                 </div>}

                 <Form.Row>
                    <Form.Group as={Col}>
                    <Button
                            variant={isInvalid?"secondary":"primary"}
                            type="button"
                            disabled={isInvalid}
                            onClick={this.onSubmit}
                        >
                            Submit
                        </Button>
                    </Form.Group>
                 </Form.Row>
                

                        
                        
                    </div>)}

                        {this.state.errorMessage !== '' && (
                            <Alert variant="danger">{errorMessage}</Alert>
                        )}

                        {this.state.successMessage !== '' && (
                            <Alert variant="success">{successMessage}</Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }

    validateForm = () => {
        let isError = false;
        let errorMsg = '';

        let PhoneNumber = this.state.PhoneNumber.replace('+91', '');
        if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Phone Number.';
        }

        if (
            !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                this.state.EmailId
            )
        ) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid EmailId.';
        }

        var reurndata = [];
        reurndata.isError = isError;
        reurndata.errorMsg = errorMsg;
        return reurndata;
    };
}

const SignUpForm = withRouter(withFirebase(SignUpFormBase));

export default SignUpPage;
export { SignUpForm };
